import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Col, Button, Form, FormControl } from "react-bootstrap";
import Select from "react-select";
import CurrencyInput from "react-currency-input-field";

import * as _ from "../../../../constants/Constants";
import * as rolePermConsts from "../../../../constants/RolePermissionConstants";
import {
  checkOnBoardingStatus,
  checkMandatoryDocStatus,
} from "../../../../utils/utils";
import BrandMappingInstructions from "./BrandMappingInstructions";
import {
  httpGetAllHierarchyDivision,
  httpGetHierarchyAllBrandNames,
  httpGetHierarchyByDivisionNumber,
  httpPostHirarchySave,
  httpGetFreightTermsByOperDiv,
  httpGetMandatoryDocumentStatus,
} from "../../../../service/httpClient";
import {
  updateServiceData,
  updateVendorProfileDetails,
} from "../../../../redux/serviceSlice";
import * as Constants from "../../../../constants/Constants";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import "../../../Common/Tooltip/ToolTip.css";
import "../../../../assets/css/Common.css";
import {
  getMultiSelectOptions,
  getMultiSelectValue,
  getSelectedOptReactSelectFromConfig,
} from "../../OnboardingHelper";

const getSortedArrayBasedOnDepartment = (hierarchyArr) => {
  return [
    ...hierarchyArr.sort((a, b) => {
      let firstDep = parseInt(a?.dept);
      let secDep = parseInt(b?.dept);

      if (firstDep && secDep) {
        return firstDep - secDep;
      }
      return;
    }),
  ];
};

const getHierarchy = (
  vendorDetails,
  rolePermissionForEntirePage,
  freightTermsOptions
) => {
  if (
    vendorDetails.hierarchyDetails &&
    vendorDetails.hierarchyDetails.length > 0
  ) {
    let unSortedHierarchyDetails = [
      ...vendorDetails.hierarchyDetails.map((item) => {
        return {
          ...item,
          freightCode:
            item.freightCode === null
              ? item.freightCode
              : item.freightCode ||
                getDefaultFreightTerms(
                  item.operatingDivision,
                  freightTermsOptions
                ),
        };
      }),
    ];
    let sortedHierarchyDetails = getSortedArrayBasedOnDepartment(
      unSortedHierarchyDetails
    );
    return [...sortedHierarchyDetails];
  }
  if (vendorDetails && rolePermissionForEntirePage === rolePermConsts.EDIT) {
    return [
      {
        dept: "",
        divisionName: "",
        gmmName: "",
        isPrimary: false,
        isOperDivPrimary: false,
        operatingDivision: "",
        vendorNumber: "",
        vendorProfileId: vendorDetails.id || "",
        brandName: "",
        terms: null,
        termsDays: null,
        freightCode: null,
        returnDisposition: "",
        salvageAllowance: "0",
      },
    ];
  }

  return [];
};

const getSortedFreightTerms = (freightTerms = []) => {
  return [
    ...freightTerms.sort((a, b) => {
      if (a.displayOrder && b.displayOrder) {
        return a.displayOrder - b.displayOrder;
      }
      return;
    }),
  ];
};

const getDefaultFreightTerms = (operDiv = "", freightTermsOptions = {}) => {
  let defaultFreightTerms = null;
  let defaultFreightOption = null;
  if (operDiv === "MACY'S") {
    defaultFreightOption = freightTermsOptions.macys?.find(
      (item) => item.isDefault
    );
  } else if (operDiv === "MACY'S BACKSTAGE") {
    defaultFreightOption = freightTermsOptions.macysBackstage?.find(
      (item) => item.isDefault
    );
  } else if (operDiv === "BLOOMINGDALE'S") {
    defaultFreightOption = freightTermsOptions.blm?.find(
      (item) => item.isDefault
    );
  } else if (operDiv === "BLOOMINGDALES OUTLET") {
    defaultFreightOption = freightTermsOptions.blmOutlet?.find(
      (item) => item.isDefault
    );
  }

  if (defaultFreightOption) {
    defaultFreightTerms = defaultFreightOption.freightCode;
  }

  return defaultFreightTerms;
};

const options = [
  {
    label: "Drop Ship",
    value: "Drop Ship",
  },
  {
    label: "Stock",
    value: "Stock",
  },
  {
    label: "LVIP",
    value: "LVIP",
  },
  {
    label: "LVIQ",
    value: "LVIQ",
  },
  {
    label: "LVIQ – On Order",
    value: "LVIQ – On Order",
  },
];

const MerchantApprovalBrand = ({ viewOnMerchApproval, details, history }) => {
  const dispatch = useDispatch();
  const store = useSelector(
    ({ service, common }) => ({
      vendorProfile: service.vendorProfile,
      vendorDetails: service.vendorProfile?.vendorDetail,
      profileId: common.profileId,
      vendorStatus: service.vendorStatus || [],
      onBoardStatus: common.boardingStatuses || {},
      vendorCorpName: common.vendorCorpName,
      userEmail: common.userEmail,
      duns: common.duns,
      notes: service.notes,
      onboardingStatus: common.boardingStatuses?.onboardingStatus,
      merchandiseType:
        service.vendorProfile?.vendorDetail?.merchandiseType || "",
      configValues: common?.configValues,
    }),
    shallowEqual
  );
  const [dvnDetails, setDvnDetails] = useState({
    vendorDetails: null,
    hierarchyArr: [],
    operatingDivisions: [],
    deptByMacys: [],
    deptByBloomingdales: [],
    deptByBloomingdalesOutlet: [],
    deptByMacysBackstage: [],
    vendorNumberByDept: {},
    disableApproveButton: false,
    disableAssignNewDVNsButton: false,
    hasDuplicateHierarchyEntry: false,
    dvnUpdateStatus: {
      error: "",
      success: "",
    },
    dvnSetupStatus: "",
    dvnSetupStatusMsg: "",
  });
  const [brandNames, setBrandNames] = useState([]);
  const [validationMesg, setValidationMesg] = useState("");
  const [hasAssignDvnData, setHasAssignDvnData] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState("");
  const [hasFormError, setHasFormError] = useState(false);
  const [freightTermsOptions, setFreightTermsOptions] = useState({
    macys: [],
    macysBackstage: [],
    blm: [],
    blmOutlet: [],
  });
  const [hasNewOrExistingBrand, setHasNewOrExistingBrand] = useState(false);
  const [dublicateMsg, setDublicateMsg] = useState("");
  const [apiErrorMsg, setApiErrorMsg] = useState("");
  const [valueChanged, setValueChanged] = useState(false);

  const vendorDetails = (dvnDetails && dvnDetails.vendorDetails) || {};
  const vendorConnectionPlatform =
    (vendorDetails && vendorDetails.vendorConnectionPlatform) || "";
  const directEdiRDS = vendorConnectionPlatform === "directEdiRDS";
  const isMPVendor =
    store?.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE;

  const getOperatingDivisions = () => {
    httpGetAllHierarchyDivision().then((res) => {
      setDvnDetails((state) => ({
        ...state,
        operatingDivisions: res.data,
      }));

      getGetFreightTermsOptions(res.data);

      if (res && res.data && res.data.length > 0) {
        res.data.forEach((operatingDivision) => {
          if (operatingDivision) {
            httpGetHierarchyByDivisionNumber(operatingDivision).then((res) => {
              const { data = [], status } = res || {};
              if (data && data.length > 0 && status === 200) {
                switch (operatingDivision) {
                  case `BLOOMINGDALE'S`:
                    setDvnDetails((state) => ({
                      ...state,
                      deptByBloomingdales: data,
                    }));
                    break;
                  case "BLOOMINGDALES OUTLET":
                    setDvnDetails((state) => ({
                      ...state,
                      deptByBloomingdalesOutlet: data,
                    }));
                    break;
                  case `MACY'S`:
                    setDvnDetails((state) => ({
                      ...state,
                      deptByMacys: data,
                    }));
                    break;
                  case `MACY'S BACKSTAGE`:
                    setDvnDetails((state) => ({
                      ...state,
                      deptByMacysBackstage: data,
                    }));
                    break;
                  default:
                    break;
                }
              }
            });
          }
        });
      }
    });
  };
  const vendorProfileDetails = store.vendorProfile.vendorDetail;
  const rolePermissionForEntireDVNPage = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
    rolePermConsts.ALL
  );
  const rolePermissionForEntireDVNPage_MA = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
    rolePermConsts.ALL
  );
  const { pathname } = history.location;

  useEffect(() => {
    getOperatingDivisions();
    const rolePermission = viewOnMerchApproval
      ? rolePermissionForEntireDVNPage_MA
      : rolePermissionForEntireDVNPage;

    httpGetHierarchyAllBrandNames(store.profileId)
      .then((res) => {
        setBrandNames(res.data || []);
      })
      .catch((err) => {
        setValidationErrorMessage("Brand names service failed");
      });
    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: getHierarchy(
        vendorProfileDetails,
        rolePermission,
        freightTermsOptions
      ),
      vendorDetails: {
        ...state.vendorDetails,
        ...vendorProfileDetails,
      },
    }));
  }, [vendorProfileDetails, store.vendorProfile]);

  const handleBrandName = (e, index) => {
    setValidationMesg("");
    let list = [...hierarchyArr];
    list[index] = { ...list[index], brandName: e.target.value };

    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: list,
    }));
    list = [...hierarchyArr];

    hasSameOrDifferentBrand(list[index].isNewBrand, e.target.value, index);

    setValueChanged(true);
  };

  const getList = (operationDivsion) => {
    switch (operationDivsion) {
      case "BLOOMINGDALES OUTLET":
        let bDOutLet = [];
        if (details && details.detail) {
          const { deptByBloomingdalesOutlet = [] } = details.detail;
          bDOutLet = deptByBloomingdalesOutlet;
          if (deptByBloomingdalesOutlet.length === 0) {
            bDOutLet = dvnDetails.deptByBloomingdalesOutlet;
          }
          return bDOutLet;
        } else {
          const { deptByBloomingdalesOutlet = [] } = dvnDetails;
          return deptByBloomingdalesOutlet;
        }
      case "MACY'S":
        let dmacys = [];
        if (details && details.detail) {
          const { deptByMacys = [] } = details.detail;
          dmacys = deptByMacys;
          if (deptByMacys.length === 0) {
            dmacys = dvnDetails.deptByMacys;
          }
          return dmacys;
        } else {
          const { deptByMacys = [] } = dvnDetails;
          return deptByMacys;
        }
      case "MACY'S BACKSTAGE":
        let dmacysBasket = [];
        if (details && details.detail) {
          const { deptByMacysBackstage = [] } = details.detail;
          dmacysBasket = deptByMacysBackstage;
          if (deptByMacysBackstage.length === 0) {
            dmacysBasket = dvnDetails.deptByMacysBackstage;
          }
          return dmacysBasket;
        } else {
          const { deptByMacysBackstage = [] } = dvnDetails;
          return deptByMacysBackstage;
        }
      case "BLOOMINGDALE'S":
        let dBdales = [];
        if (details && details.detail) {
          const { deptByBloomingdales = [] } = details.detail;
          dBdales = deptByBloomingdales;
          if (deptByBloomingdales.length === 0) {
            dBdales = dvnDetails.deptByBloomingdales;
          }
          return dBdales;
        } else {
          const { deptByBloomingdales = [] } = dvnDetails;
          return deptByBloomingdales;
        }
      default:
        return [];
    }
  };

  const getDeptNumbet = (operationDivsion, num) => {
    switch (operationDivsion) {
      case "BLOOMINGDALES OUTLET":
        const boList = getList("BLOOMINGDALES OUTLET");
        if (boList && boList.length > 0) {
          let obj = boList.find(
            (item) => item["deptNbr"] === parseInt(num, 10)
          );
          if (obj) {
            return num + "-" + obj["divnDeptDesc"];
          }
        }
        return "";

      case "MACY'S":
        const macyList = getList("MACY'S");
        if (macyList && macyList.length > 0) {
          const obj1 = macyList.find(
            (item) => item["deptNbr"] === parseInt(num, 10)
          );
          if (obj1) {
            return num + "-" + obj1["divnDeptDesc"];
          }
        }
        return "";
      case "MACY'S BACKSTAGE":
        const macyBksList = getList("MACY'S BACKSTAGE");
        if (macyBksList && macyBksList.length > 0) {
          const obj2 = macyBksList.find(
            (item) => item["deptNbr"] === parseInt(num, 10) && item
          );
          if (obj2) {
            return num + "-" + obj2["divnDeptDesc"];
          }
        }
        return "";
      case "BLOOMINGDALE'S":
        const bloomingList = getList("BLOOMINGDALE'S");
        if (bloomingList && bloomingList.length > 0) {
          const obj3 = bloomingList.find(
            (item) => item["deptNbr"] === parseInt(num, 10)
          );
          if (obj3) {
            return num + "-" + obj3["divnDeptDesc"];
          }
        }
        return "";
      default:
        return "";
    }
  };
  const { hierarchyArr = [] } = dvnDetails;

  const handleChange = (e, filedName, index) => {
    setValidationMesg("");
    setApiErrorMsg("");
    let list = [...hierarchyArr];

    if (filedName === "terms") {
      const termLimit = list[index].percentLimit;
      let val = e.target.value;

      if (!val || parseInt(val) <= parseInt(termLimit)) {
        setHasFormError(false);
        setValidationErrorMessage("");
      } else {
        setHasFormError(true);
        setValidationErrorMessage(
          `PercentLimit can not be more than ${termLimit}`
        );
      }
    }
    if (filedName === "termsDays") {
      let val = e.target.value;
      if (
        !val ||
        parseInt(val) < getTermDaysDefaultMinValue() ||
        parseInt(val) > 999
      ) {
        const isMinority = store.vendorDetails?.certifiedAsMinority;
        setHasFormError(true);
        setValidationErrorMessage(
          isMinority
            ? Constants.TERMS_DAYS_ERROR_MSG
            : Constants.TERMS_DAYS_NON_MINORITY_ERROR_MSG
        );
      } else {
        setHasFormError(false);
        setValidationErrorMessage("");
      }
    }
    if (filedName === "salvageAllowance") {
      const salvAllowRegexValidate = Constants.REGEX_NUMBER_ZERO_TO_NINE;
      let val = e.target.value;

      if (!val || !val.match(salvAllowRegexValidate)) {
        setHasFormError(true);
        setValidationErrorMessage(
          Constants.MSG_SALVAGE_ALLOWANCE_LIMIT_VALIDATION
        );
      } else {
        setHasFormError(false);
        setValidationErrorMessage("");
      }
    }
    if (filedName === "receiptAllowance") {
      const salvAllowRegexValidate = Constants.REGEX_NUMBER_ZERO_TO_FIFTY;
      let val = e.target.value;
      if (list[index]?.vendorNumber === "0") {
        if (
          val === undefined ||
          val === null ||
          !val ||
          !val.match(salvAllowRegexValidate)
        ) {
          setHasFormError(true);
          setValidationErrorMessage(
            Constants.MSG_ALLOWANCE_RATE_LIMIT_VALIDATION
          );
        } else {
          setHasFormError(false);
          setValidationErrorMessage("");
        }
      }
    }
    list[index] = { ...list[index], [filedName]: e.target.value };

    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: list,
    }));

    setValueChanged(true);
  };

  const handleChangeReturnDisp = (e, fieldName, index) => {
    setValidationMesg("");
    const list = [...hierarchyArr];

    let fieldVal = "";
    if (typeof e?.value !== "undefined") {
      //single select
      fieldVal = e.value || "";
    } else if (directEdiRDS && typeof e === "object") {
      //multiselect in case of directEdiRDS
      e &&
        e.forEach((obj) => {
          fieldVal = fieldVal ? `${fieldVal}|${obj.value}` : obj.value;
        });
    }
    list[index] = {
      ...list[index],
      [fieldName]: fieldVal,
      salvageAllowance: list?.salvageAllowance || "0",
    };

    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: list,
    }));

    if (e?.value) {
      setValueChanged(true);
    } else {
      setValueChanged(false);
    }
  };

  const handleNewOrExisting = (e, fieldName, index) => {
    setValidationMesg("");
    let list = [...hierarchyArr];
    let value = e.target.value;
    list[index] = { ...list[index], [fieldName]: value };

    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: list,
    }));
    if (fieldName === "isNewBrand") {
      hasSameOrDifferentBrand(value, list[index].brandName, index);
    }

    setValueChanged(true);
  };

  const onProgramTypesChange = (e, filedName, index) => {
    setValidationMesg("");
    const list = [...hierarchyArr];
    list[index] = {
      ...list[index],
      [filedName]: (e && e.map((i) => i.value)) || [],
    };

    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: list,
    }));

    setValueChanged(true);
  };

  const handleReturnMerchantOrDvn = () => {
    if (pathname.includes("merchantbrand")) {
      let mandatoryDocsUploaded = false;
      dispatch(updateServiceData({ fetching: true }));
      httpGetMandatoryDocumentStatus(store.profileId)
        .then((res) => {
          if (res.data) {
            mandatoryDocsUploaded = checkMandatoryDocStatus(
              store.onboardingStatus,
              res.data
            );
          }
          dispatch(updateServiceData({ fetching: false }));
          history.push(`/boarding/merchant/${store.profileId}`, {
            mandatoryDocsUploaded,
          });
        })
        .catch((err) => {
          dispatch(updateServiceData({ fetching: false }));
          history.push(`/boarding/merchant/${store.profileId}`, {
            mandatoryDocsUploaded: false,
          });
        });
    } else {
      dispatch(updateServiceData({ fetching: true }));
      history.push(`/boarding/vendor/dvnsetup/${store.profileId}`);
    }
  };

  const handleSave = () => {
    const { hierarchyArr = [] } = dvnDetails;
    let payLoad = {};
    payLoad.hierarchyList = hierarchyArr.map((item) => {
      return {
        ...item,
        duns: store.duns || "",
      };
    });
    payLoad.activity = "brandmapping";

    httpPostHirarchySave(payLoad)
      .then((res) => {
        if (res && res.data) {
          if (res.status === 200) {
            setValidationMesg("Data saved successfully");
            setApiErrorMsg("");
            setValidationErrorMessage("");
            setValueChanged(false);

            dispatch(
              updateVendorProfileDetails({
                hierarchyDetails: hierarchyArr,
              })
            );
          }
        }
      })
      .catch((err) => {
        if (
          err.response &&
          (err.response.status === 404 || err.response.status === 400)
        ) {
          setValidationMesg("");
          setValidationErrorMessage("");
          setApiErrorMsg(err.response.data?.message);
        } else {
          setValidationMesg("");
          setValidationErrorMessage("");
          setApiErrorMsg(err.message);
        }
      });
  };

  const setDefaultBrandNames = () => {
    if (brandNames && brandNames.length === 1) {
      let list = [...hierarchyArr];

      const newList = list.map((item) => {
        const obj = { ...item };
        if (item && item.vendorNumber === "0") {
          obj["brandName"] = brandNames[0];
        }
        return obj;
      });
      setDvnDetails((state) => ({
        ...state,
        hierarchyArr: newList,
      }));
    }
  };

  useEffect(() => {
    getDisableSaveBtn();
  }, [hierarchyArr, dvnDetails]);

  useEffect(() => {
    setDefaultBrandNames();
  }, [brandNames]);

  useEffect(() => {
    getDisableSaveBtn();
  }, []);

  const onboadStatus = checkOnBoardingStatus(
    store.onBoardStatus.onboardingStatus?.toLowerCase(),
    [_.DBM_APPROVED?.toLowerCase()]
  );

  let rolePermissionForApAdmin =
    getUserRolePermission(
      rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
      rolePermConsts.VMP_BRANDMAPPING_FIELDS
    ) === rolePermConsts.EDIT &&
    pathname.includes("dvnsetup") &&
    onboadStatus;

  const getTermDaysDefaultMinValue = () => {
    const isMinority = store.vendorDetails?.certifiedAsMinority;
    const minValue = isMinority ? 30 : 1;
    return minValue;
  };
  const getDisableSaveBtn = () => {
    let status = false;
    if (!hierarchyArr) {
      return false;
    }
    let count = 0;
    const validationRequiredKeys = [
      "brandName",
      "terms",
      "termsDays",
      "isNewBrand",
      "internationalShippingAllowed",
      "freightCode",
    ];
    if (store?.merchandiseType !== Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE) {
      validationRequiredKeys.push("returnDisposition");
    }
    hierarchyArr.forEach((item) => {
      const keys =
        item.vendorNumber === "0"
          ? validationRequiredKeys
          : ["termsDays", "freightCode"];
      if (!status) {
        for (let key of keys) {
          if (
            item &&
            (item[key] === null ||
              item[key] === "" ||
              item[key] === undefined ||
              item[key] === "none" ||
              (key === "termsDays" &&
                item[key] &&
                (parseInt(item[key]) < getTermDaysDefaultMinValue() ||
                  parseInt(item[key]) > 999)))
          ) {
            status = true;
            setHasFormError(true);
            break;
          }
          if (directEdiRDS) {
            const prgTypeArray = item["programTypes"] || [];
            if (prgTypeArray.length === 0) {
              status = true;
              setHasFormError(true);
              break;
            }
          }
          count++;
        }
        if (
          store?.merchandiseType !== Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
        ) {
          if (
            typeof item.salvageAllowance !== "undefined" &&
            !item?.salvageAllowance?.match(Constants.REGEX_NUMBER_ZERO_TO_NINE)
          ) {
            status = true;
            setHasFormError(true);
            count++;
          }
          if (typeof item?.receiptAllowance !== "undefined") {
            if (item?.vendorNumber === "0") {
              if (
                item?.receiptAllowance === undefined ||
                item?.receiptAllowance === null ||
                !item?.receiptAllowance ||
                !item?.receiptAllowance?.match(
                  Constants.REGEX_NUMBER_ZERO_TO_FIFTY
                )
              ) {
                status = true;
                setHasFormError(true);
                count++;
              }
            }
          }
        }
      }
    });
    if (hierarchyArr.length === count) {
      setHasAssignDvnData(true);
    } else {
      setHasAssignDvnData(false);
    }
    if (!status) {
      setHasFormError(false);
    }
  };

  const getBrandName = (item) => {
    if (item && item.vendorNumber !== "0") {
      if (item && item.brandName) {
        return item.brandName;
      } else {
        return "";
      }
    } else {
      if (brandNames && brandNames.length === 1) {
        return brandNames[0];
      }
    }
  };

  const getGetFreightTermsOptions = async (operatingDivision) => {
    let operatingDiv = new Set();
    for (const hierarchy of operatingDivision) {
      operatingDiv.add(hierarchy);
    }

    let apiCalls = [];
    for (const operDiv of operatingDiv) {
      if (operDiv === "MACY'S" && freightTermsOptions.macys.length === 0) {
        apiCalls.push(httpGetFreightTermsByOperDiv(12));
      } else if (
        operDiv === "MACY'S BACKSTAGE" &&
        freightTermsOptions.macysBackstage.length === 0
      ) {
        apiCalls.push(httpGetFreightTermsByOperDiv(6315));
      } else if (
        operDiv === "BLOOMINGDALE'S" &&
        freightTermsOptions.blm.length === 0
      ) {
        apiCalls.push(httpGetFreightTermsByOperDiv(13));
      } else if (
        operDiv === "BLOOMINGDALES OUTLET" &&
        freightTermsOptions.blmOutlet.length === 0
      ) {
        apiCalls.push(httpGetFreightTermsByOperDiv(1027));
      }
    }

    if (apiCalls.length > 0) {
      try {
        const responses = await Promise.all(apiCalls);
        if (responses && responses.length > 0) {
          let freightTerms = { ...freightTermsOptions };
          for (let res of responses) {
            if (res.status === 200) {
              let urlSegments = res.config?.url?.split("/") || [];
              if (urlSegments.length > 0) {
                switch (parseInt(urlSegments[urlSegments.length - 1])) {
                  case 13:
                    freightTerms.blm = getSortedFreightTerms(res.data);
                    break;
                  case 1027:
                    freightTerms.blmOutlet = getSortedFreightTerms(res.data);
                    break;
                  case 12:
                    freightTerms.macys = getSortedFreightTerms(res.data);
                    break;
                  case 6315:
                    freightTerms.macysBackstage = getSortedFreightTerms(
                      res.data
                    );
                    break;
                  default:
                    break;
                }
              }
            }
          }

          setFreightTermsOptions(freightTerms);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const renderFreightTermsOptions = (operDiv) => {
    if (operDiv === "MACY'S") {
      return freightTermsOptions.macys;
    } else if (operDiv === "MACY'S BACKSTAGE") {
      return freightTermsOptions.macysBackstage;
    } else if (operDiv === "BLOOMINGDALE'S") {
      return freightTermsOptions.blm;
    } else if (operDiv === "BLOOMINGDALES OUTLET") {
      return freightTermsOptions.blmOutlet;
    }

    return [];
  };

  const handleFreightTerms = (e, index) => {
    setValidationMesg("");
    let list = [...hierarchyArr];
    list[index] = { ...list[index], freightCode: e.target.value };

    setDvnDetails((state) => ({
      ...state,
      hierarchyArr: list,
    }));

    setValueChanged(true);
  };

  const getFrieghtDesc = (freightCode, operDiv) => {
    let selectedFreighTerms = null;
    if (operDiv === "MACY'S") {
      selectedFreighTerms = freightTermsOptions.macys.find(
        (item) => item.freightCode === freightCode
      );
    } else if (operDiv === "MACY'S BACKSTAGE") {
      selectedFreighTerms = freightTermsOptions.macysBackstage.find(
        (item) => item.freightCode === freightCode
      );
    } else if (operDiv === "BLOOMINGDALE'S") {
      selectedFreighTerms = freightTermsOptions.blm.find(
        (item) => item.freightCode === freightCode
      );
    } else if (operDiv === "BLOOMINGDALES OUTLET") {
      selectedFreighTerms = freightTermsOptions.blmOutlet.find(
        (item) => item.freightCode === freightCode
      );
    }

    return selectedFreighTerms?.freightDesc || "";
  };

  const hasSameOrDifferentBrand = (element, brandName, idx) => {
    let list = [...hierarchyArr];
    let isDublicate = false;
    for (let index = 0; index < list.length; index++) {
      const currentValue = list[index];
      if (
        index !== idx &&
        currentValue.vendorNumber === "0" &&
        currentValue.brandName &&
        element &&
        (!currentValue.isNewBrand ||
          !currentValue.isNewBrand ||
          (currentValue.brandName === brandName &&
            currentValue.isNewBrand !== element))
      ) {
        isDublicate = true;
        break;
      } else {
        isDublicate = false;
      }
    }

    if (isDublicate) {
      setDublicateMsg(Constants.VERBIAGE_BRAND_NEW_AND_EXISTING);
      setValidationMesg("");
    } else {
      setDublicateMsg("");
    }
    setHasNewOrExistingBrand(isDublicate);
  };
  const newOrExisting = ["Y", "N"];
  const newOrExistingMap = { Y: "New", N: "Existing" };
  const yesOrNoOptions = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ];

  return (
    <div style={{ marginTop: "10px" }} className="merchantOrDvnBrandContainer">
      <p className="validationSuccessMsg" style={{ marginLeft: "10px" }}>
        {validationMesg}
      </p>
      <p className="validationErrorMsg" style={{ marginLeft: "10px" }}>
        {validationErrorMessage}
      </p>
      <p className="validationErrorMsg" style={{ marginLeft: "10px" }}>
        {dublicateMsg}
      </p>
      <p className="validationErrorMsg" style={{ marginLeft: "10px" }}>
        {apiErrorMsg}
      </p>
      <div className="brand_mapping_container">
        <Form
          style={
            isMPVendor
              ? {
                  width: "1600px",
                  overflowX: "hidden",
                  paddingRight: "20px",
                }
              : directEdiRDS
              ? {
                  width: "3000px",
                  overflowX: "hidden",
                  paddingRight: "20px",
                }
              : {
                  width: "2600px",
                  overflowX: "auto",
                  paddingRight: "20px",
                }
          }
          name="DvnForm"
        >
          <>
            {hierarchyArr.length > 0 ? (
              <>
                <Form.Row
                  key="view_header_dvn"
                  className="ml-2 view_details"
                  style={{ width: "100% !important" }}
                >
                  <Col>
                    <Form.Label className="font-weight-bold">
                      Operating Division
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label className="font-weight-bold">
                      Department Number
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label className="font-weight-bold">
                      Vendor Number
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label className="font-weight-bold">Brand</Form.Label>
                  </Col>

                  <Col>
                    <Form.Label className="font-weight-bold text-center">
                      New or Existing Brand?
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label className="font-weight-bold text-center">
                      International Shipping?
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label className="font-weight-bold">
                      Terms %
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label className="font-weight-bold">
                      Terms Days
                    </Form.Label>
                    <span className="required">*</span>
                  </Col>
                  {directEdiRDS && (
                    <Col>
                      <Form.Label className="font-weight-bold">
                        Big Ticket Program
                      </Form.Label>
                    </Col>
                  )}
                  <Col>
                    <Form.Label className="font-weight-bold">
                      Freight Terms
                    </Form.Label>
                    <span className="required">*</span>
                  </Col>
                  {store?.merchandiseType !==
                    Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE && (
                    <>
                      <Col>
                        <Form.Label className="font-weight-bold">
                          Return Disposition
                        </Form.Label>
                        {<span className="required">*</span>}
                      </Col>
                      <Col>
                        <Form.Label className="font-weight-bold">
                          Salvage Allowance %
                        </Form.Label>
                      </Col>
                      <Col>
                        <Form.Label className="font-weight-bold">
                          Receipt Allowance(%)
                          <span className="required">*</span>
                        </Form.Label>
                      </Col>
                    </>
                  )}
                </Form.Row>
                {hierarchyArr.map((item, index) => (
                  <Form.Row
                    key={"primaryDVNS_view_row" + index}
                    className="ml-2 view_details"
                    style={{ width: "max-content !important" }}
                  >
                    <Form.Group as={Col}>
                      <Form.Control
                        id={"dvnOperDiv" + index}
                        defaultValue={item && item.operatingDivision}
                        disabled
                      />
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Control
                        id={"dvnDeptNumber" + index}
                        defaultValue={
                          item &&
                          getDeptNumbet(item.operatingDivision, item.dept)
                        }
                        disabled
                      />
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Control
                        id={"dvnVendNumber" + index}
                        defaultValue={
                          item && item.vendorNumber && item.vendorNumber !== "0"
                            ? item.vendorNumber
                            : _.ASSIGN_NEW_DVN
                        }
                        disabled
                      />
                    </Form.Group>
                    {(brandNames && brandNames.length === 1) ||
                    item.vendorNumber !== "0" ? (
                      <Form.Group as={Col}>
                        <Form.Control
                          id={"dvnVendNumber" + index}
                          defaultValue={getBrandName(item)}
                          disabled
                        />
                      </Form.Group>
                    ) : (
                      <Form.Group as={Col}>
                        <FormControl
                          as="select"
                          name={"multipleBrandName" + index}
                          defaultValue={
                            brandNames && brandNames.length === 1
                              ? brandNames[0]
                              : _.SELECT_ONE
                          }
                          value={
                            (brandNames &&
                              brandNames.length === 1 &&
                              brandNames[0]) ||
                            item.brandName ||
                            _.SELECT_ONE
                          }
                          title={
                            (brandNames &&
                              brandNames.length === 1 &&
                              brandNames[0]) ||
                            item.brandName ||
                            _.SELECT_ONE
                          }
                          onChange={(event) => {
                            handleBrandName(event, index);
                          }}
                          disabled={
                            (item &&
                              item.vendorNumber &&
                              item.vendorNumber !== "0" &&
                              item.brandName) ||
                            (brandNames && brandNames.length === 1) ||
                            (item?.vendorNumber === "0" &&
                              onboadStatus &&
                              !rolePermissionForApAdmin)
                          }
                        >
                          <option value="" selected hidden>
                            {_.SELECT_ONE}
                          </option>
                          {brandNames.map((option, oi) => (
                            <option value={option} key={oi}>
                              {option}
                            </option>
                          ))}
                          <option value="Class-Level Mapping*">
                            Class-Level Mapping*
                          </option>
                        </FormControl>
                      </Form.Group>
                    )}
                    {item.vendorNumber !== "0" ? (
                      <Form.Group as={Col}>
                        <Form.Control
                          id={"newOrExisting" + index}
                          value={
                            item.isNewBrand === "Y"
                              ? "New"
                              : item.isNewBrand === "N"
                              ? "Existing"
                              : ""
                          }
                          disabled
                        />
                      </Form.Group>
                    ) : (
                      <Form.Group as={Col}>
                        <FormControl
                          as="select"
                          name="newOrExisting"
                          value={item.isNewBrand || ""}
                          title={
                            item.isNewBrand === "Y"
                              ? "New"
                              : item.isNewBrand === "N"
                              ? "Existing"
                              : _.SELECT_ONE
                          }
                          onChange={(event) => {
                            handleNewOrExisting(event, "isNewBrand", index);
                          }}
                          disabled={onboadStatus && !rolePermissionForApAdmin}
                        >
                          <option value="" selected hidden>
                            {_.SELECT_ONE}
                          </option>
                          {newOrExisting.map((option, oi) => (
                            <option value={option} key={oi}>
                              {newOrExistingMap[option]}
                            </option>
                          ))}
                        </FormControl>
                      </Form.Group>
                    )}
                    {item.vendorNumber !== "0" ? (
                      <Form.Group as={Col}>
                        <Form.Control
                          id={"internationalShippingAllowed" + index}
                          value={
                            item.internationalShippingAllowed === "Y"
                              ? "Yes"
                              : item.internationalShippingAllowed === "N"
                              ? "No"
                              : ""
                          }
                          disabled
                        />
                      </Form.Group>
                    ) : (
                      <Form.Group as={Col}>
                        <FormControl
                          as="select"
                          name="internationalShippingAllowed"
                          value={item.internationalShippingAllowed || ""}
                          title={
                            item.internationalShippingAllowed === "Y"
                              ? "Yes"
                              : item.internationalShippingAllowed === "N"
                              ? "No"
                              : _.SELECT_ONE
                          }
                          onChange={(event) => {
                            handleNewOrExisting(
                              event,
                              "internationalShippingAllowed",
                              index
                            );
                          }}
                          disabled={onboadStatus && !rolePermissionForApAdmin}
                        >
                          <option value="" selected hidden>
                            {_.SELECT_ONE}
                          </option>
                          {yesOrNoOptions.map((option, oi) => (
                            <option value={option.value} key={oi}>
                              {option.label}
                            </option>
                          ))}
                        </FormControl>
                      </Form.Group>
                    )}
                    <Form.Group as={Col}>
                      <CurrencyInput
                        id={"terms" + index}
                        automationid={"terms" + index}
                        name={"terms" + index}
                        className="form-control"
                        style={{
                          textAlign: "right",
                        }}
                        onValueChange={(value) => {
                          const event = {
                            target: {
                              name: "terms" + index,
                              value: value ? (value > 100 ? "100" : value) : "",
                            },
                          };
                          handleChange(event, "terms", index);
                        }}
                        onBlur={(e) => {
                          const { value } = e.target;
                          const event = {
                            target: {
                              name: "terms" + index,
                              value:
                                value && !isNaN(parseFloat(value))
                                  ? parseFloat(value).toString()
                                  : "",
                            },
                          };
                          handleChange(event, "terms", index);
                        }}
                        defaultValue={item && item.terms}
                        value={(item && item.terms) || ""}
                        decimalsLimit={1}
                        disableGroupSeparators={true}
                        allowNegativeValue={false}
                        placeholder="%"
                        suffix=" %"
                        disabled={
                          (item &&
                            item.vendorNumber &&
                            item.vendorNumber !== "0") ||
                          (item?.vendorNumber === "0" &&
                            onboadStatus &&
                            !rolePermissionForApAdmin)
                        }
                      />
                    </Form.Group>
                    <Form.Group as={Col}>
                      <CurrencyInput
                        id={"days" + index}
                        automationid={"days" + index}
                        name={"days" + index}
                        className="form-control"
                        style={{
                          textAlign: "right",
                        }}
                        onValueChange={(value) => {
                          const event = {
                            target: {
                              name: "days" + index,
                              value:
                                value && !isNaN(Number(value))
                                  ? Math.floor(Number(value)).toString()
                                  : "",
                            },
                          };
                          handleChange(event, "termsDays", index);
                        }}
                        defaultValue={item && item.termsDays}
                        value={(item && item.termsDays) || ""}
                        decimalsLimit={0}
                        decimalScale={0}
                        disableGroupSeparators={true}
                        allowNegativeValue={false}
                        placeholder="days"
                        suffix=" days"
                        disabled={onboadStatus && !rolePermissionForApAdmin}
                      />
                    </Form.Group>
                    {directEdiRDS && (
                      <Form.Group as={Col}>
                        <Select
                          id={"programTypes"}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          placeholder={Constants.SELECT_ALL_APPLY}
                          options={options}
                          blurInputOnSelect={false}
                          value={
                            item &&
                            item.programTypes &&
                            item.programTypes.map((progType) => {
                              let programTypeObj = {
                                label: progType,
                                value: progType,
                              };

                              return programTypeObj;
                            })
                          }
                          onChange={(value) =>
                            onProgramTypesChange(value, "programTypes", index)
                          }
                          className="react-select  searchSelect"
                          isSearchable
                          isClearable
                          isMulti={true}
                        />
                      </Form.Group>
                    )}
                    <Form.Group as={Col}>
                      <FormControl
                        id={"freightCode" + index}
                        as="select"
                        name="freightCode"
                        value={item.freightCode || _.SELECT_ONE}
                        title={
                          getFrieghtDesc(
                            item.freightCode,
                            item.operatingDivision
                          ) || _.SELECT_ONE
                        }
                        onChange={(event) => {
                          handleFreightTerms(event, index);
                        }}
                        disabled={onboadStatus && !rolePermissionForApAdmin}
                      >
                        <option value="" selected hidden>
                          {_.SELECT_ONE}
                        </option>
                        {renderFreightTermsOptions(item.operatingDivision).map(
                          (option, oi) => {
                            return (
                              <option value={option.freightCode} key={oi}>
                                {option.freightDesc}
                              </option>
                            );
                          }
                        )}
                      </FormControl>
                    </Form.Group>
                    {store?.merchandiseType !==
                      Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE && (
                      <>
                        <Form.Group as={Col}>
                          <Select
                            id={"returnDisposition" + index}
                            name="returnDisposition"
                            className="react-select searchSelect"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            options={getMultiSelectOptions(
                              "returnDisposition",
                              store?.configValues
                            )}
                            value={
                              item?.returnDisposition !== null && directEdiRDS
                                ? getMultiSelectValue(
                                    "returnDisposition",
                                    item,
                                    store?.configValues
                                  )
                                : item?.returnDisposition !== null
                                ? getSelectedOptReactSelectFromConfig(
                                    "returnDisposition",
                                    item,
                                    store?.configValues
                                  )
                                : ""
                            }
                            onChange={(event) => {
                              handleChangeReturnDisp(
                                event,
                                "returnDisposition",
                                index
                              );
                            }}
                            blurInputOnSelect={false}
                            isMulti={directEdiRDS}
                            isSearchable
                            isClearable
                            isDisabled={
                              onboadStatus && !rolePermissionForApAdmin
                            }
                          ></Select>
                        </Form.Group>

                        <Form.Group as={Col}>
                          <CurrencyInput
                            id={"salvageAllowance" + index}
                            automationid={"salvageAllowance" + index}
                            name={"salvageAllowance" + index}
                            className="form-control"
                            style={{
                              textAlign: "right",
                            }}
                            onValueChange={(value) => {
                              const event = {
                                target: {
                                  name: "salvageAllowance" + index,
                                  value: value
                                    ? value > 100
                                      ? "100"
                                      : value
                                    : "0",
                                },
                              };
                              handleChange(event, "salvageAllowance", index);
                            }}
                            onBlur={(e) => {
                              const { value } = e.target;
                              const event = {
                                target: {
                                  name: "salvageAllowance" + index,
                                  value:
                                    value && !isNaN(parseFloat(value))
                                      ? parseFloat(value).toString()
                                      : "0",
                                },
                              };
                              handleChange(event, "salvageAllowance", index);
                            }}
                            defaultValue={
                              (item && item.salvageAllowance) || "0"
                            }
                            value={(item && item.salvageAllowance) || "0"}
                            decimalsLimit={1}
                            disableGroupSeparators={true}
                            allowNegativeValue={false}
                            placeholder="%"
                            suffix=" %"
                            disabled={
                              item.returnDisposition === null ||
                              typeof item.returnDisposition === "undefined" ||
                              (typeof item.returnDisposition === "string" &&
                                item?.returnDisposition.indexOf("salAllow") ===
                                  -1) ||
                              store.vendorDetails?.merchandiseType ===
                                Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT ||
                              (onboadStatus && !rolePermissionForApAdmin)
                            }
                          />
                        </Form.Group>
                        <Form.Group as={Col}>
                          <CurrencyInput
                            id={"receiptAllowance" + index}
                            automationid={"receiptAllowance" + index}
                            name={"receiptAllowance" + index}
                            className="form-control"
                            style={{
                              textAlign: "right",
                            }}
                            onValueChange={(value) => {
                              const event = {
                                target: {
                                  name: "receiptAllowance" + index,
                                  value: value
                                    ? value > 100
                                      ? "100"
                                      : value
                                    : "0",
                                },
                              };
                              handleChange(event, "receiptAllowance", index);
                            }}
                            onBlur={(e) => {
                              const { value } = e.target;
                              const event = {
                                target: {
                                  name: "receiptAllowance" + index,
                                  value:
                                    value && !isNaN(parseFloat(value))
                                      ? parseFloat(value).toString()
                                      : "0",
                                },
                              };
                              handleChange(event, "receiptAllowance", index);
                            }}
                            defaultValue={
                              (item && item.receiptAllowance) || "0"
                            }
                            value={(item && item.receiptAllowance) || "0"}
                            decimalsLimit={1}
                            disableGroupSeparators={true}
                            allowNegativeValue={false}
                            placeholder="%"
                            suffix=" %"
                            disabled={onboadStatus && !rolePermissionForApAdmin}
                          />
                        </Form.Group>
                      </>
                    )}
                  </Form.Row>
                ))}
              </>
            ) : (
              <span>No Department and Vendor number available.</span>
            )}
          </>
        </Form>
      </div>
      <div>
        <div className="flexContainer merBtnAlign mb-2 pr-3">
          <div
            className={
              pathname.includes("merchantbrand")
                ? "manageReturnToMerOrDvnBtn"
                : "manageReturnToDvnBtn"
            }
          >
            <Button
              id="manageMerchantContactsBtn"
              size="md"
              className="btn-primary-merchant merchantBrandNavigateBtn"
              onClick={handleReturnMerchantOrDvn}
              disabled={false}
            >
              {pathname.includes("merchantbrand")
                ? Constants.RETURN_TO_MERCHANT_APPROVAL
                : Constants.RETURN_TO_DVN_SETUP}
            </Button>
          </div>
          <div className="brandBtn">
            <Button
              id="merApprovebrandBtn"
              size="md"
              className="button-primary-md "
              onClick={handleSave}
              disabled={
                (onboadStatus && !rolePermissionForApAdmin) ||
                hasAssignDvnData ||
                hasFormError ||
                hasNewOrExistingBrand ||
                !valueChanged
              }
            >
              Save
            </Button>
          </div>
        </div>
      </div>
      <div>
        <BrandMappingInstructions />
      </div>
    </div>
  );
};
export default MerchantApprovalBrand;
